import jwtDecode from 'jwt-decode';
import { useMemo } from 'react';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';

const VEX_AUTH_ACTION_ROUTE_PATH = 'vex/auth/action';

export const usePaymentIdFromUrl = () => {
  const { paymentId: pathParamPaymentId } = useParams<{ paymentId?: string }>();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const paymentIdFromUrl = useMemo(() => {
    if (pathParamPaymentId) {
      return pathParamPaymentId;
    }

    const isAuthActionRoute = location.pathname.endsWith(VEX_AUTH_ACTION_ROUTE_PATH);
    const token = searchParams.get('token');

    if (isAuthActionRoute && token) {
      try {
        const { actionData } = jwtDecode<{ actionData: { paymentId: string } }>(token);
        return actionData.paymentId;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(`failed to decode the given token: ${token}`);
        return undefined;
      }
    }

    return undefined;
  }, [location.pathname, pathParamPaymentId, searchParams]);

  return paymentIdFromUrl;
};
